var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSidePanelCloseRight = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h20v20H0z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M3 10.406h9.834M8.765 6.337l4.069 4.07-4.07 4.068M16.242 14.475V6.337"
}))));
export { SvgSidePanelCloseRight as ReactComponent };
export default __webpack_public_path__ + "assets/images/side-panel-close-right.svg";